import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';

import Input from '/@/v3/components/forms/input';
import Select from '/@/v3/components/forms/select';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@autobind
export default class PerformanceField extends Component {
    static propTypes = {
        title: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.any,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.any.isRequired,
            })
        ).isRequired,
        onChangeSelect: PropTypes.func.isRequired,
        valueSelect: PropTypes.any,
        dryMaterial: PropTypes.bool,
        performance: PropTypes.string,
        placeholder: PropTypes.string,
        onClickBtn: PropTypes.func,
        valueDisabled: PropTypes.bool,
        zIndex: PropTypes.oneOf(['one', 'two', 'three', 'four']),
    };
    static defaultProps = {
        valueDisabled: false,
    };

    static contextTypes = {
        units: PropTypes.object,
    };

    render() {
        const index = classNames(styles[`z-index-${this.props.zIndex}`], styles.width);

        const unit = this.context.units.getUnit('weight/area');

        return (
            <div className={styles.root}>
                <Title className={styles.title}>{this.props.title}</Title>
                <div className={styles.select}>
                    <Select
                        options={this.props.options}
                        placeholder={this.props.placeholder}
                        onChange={this.props.onChangeSelect}
                        color={settings.app.theme}
                        className={index}
                        value={this.props.valueSelect}
                        maxHeight='200px'
                    />

                    <span id={styles.icon} className='material-icons' onClick={this.props.onClickBtn}>
                        close
                    </span>
                </div>

                <div className={this.props.dryMaterial ? '' : styles.inputWrapper}>
                    <Input
                        type='number'
                        placeholder={this.props.dryMaterial ? _('Volumen de materia seca aplicado') : _('Producción')}
                        onChange={this.props.onChange}
                        color={settings.app.theme}
                        suffix={`(${unit})`}
                        extraClass={this.props.dryMaterial ? styles.inputDryMaterial : undefined}
                        disabled={this.props.valueDisabled}
                    />
                    {!this.props.dryMaterial && (
                        <div className={styles.sideText}>
                            <p className={styles.text}>{_('Materia seca')}</p>
                            <p className={styles.performance}>{this.props.performance}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
